import {Link} from "react-router-dom";
import React from "react";


import {ReactComponent as LogoIcon} from 'src/assets/logo2.svg';

interface MenuProps {
    isOpen?: boolean;
    onClose?: () => void;
}

const Menu: React.FC<MenuProps> = ({ isOpen, onClose }) => {

    return (
        <nav className={`nxl-navigation${isOpen ? ' mob-navigation-active' : ''}`}>
            <div className="navbar-wrapper">
                <div className="m-header">
                    <a href="/admin" className="b-brand flex flex-row gap-4 justify-center items-center">
                        <LogoIcon className="logo logo-lg"/>
                    </a>
                </div>
                <div className="navbar-content">
                    <ul className="nxl-navbar">
                        <li className="nxl-item nxl-caption">
                            <label>Navigation</label>
                        </li>
                        <li className="nxl-item nxl-hasmenu">
                            <a href="javascript:void(0);" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-airplay"></i></span>
                                <span className="nxl-mtext">Dashboards</span><span className="nxl-arrow"><i
                                className="feather-chevron-right"></i></span>
                            </a>
                            <ul className="nxl-submenu">
                                <li className="nxl-item"><Link className="nxl-link" to="/admin">기본 지표</Link></li>
                                <li className="nxl-item"><Link className="nxl-link" to="/adminAnalytics">로그 및 랭킹 분석</Link></li>
                            </ul>
                        </li>
                        <li className="nxl-item nxl-hasmenu">
                            <a href="javascript:void(0);" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-users"></i></span>
                                <span className="nxl-mtext">회원</span><span className="nxl-arrow"><i
                                className="feather-chevron-right"></i></span>
                            </a>
                            <ul className="nxl-submenu">
                                <li className="nxl-item"><Link className="nxl-link" to="/adminAuthor">승인 작가 관리</Link></li>
                                <li className="nxl-item"><Link className="nxl-link" to="/adminEnroll">작가 심사</Link></li>
                                <li className="nxl-item"><Link className="nxl-link" to="/adminBook">작품 관리</Link></li>
                                <li className="nxl-item"><Link className="nxl-link" to="/adminPostCard">엽서 관리</Link></li>
                            </ul>
                        </li>
                        <li className="nxl-item nxl-hasmenu">
                            <a href="javascript:void(0);" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-shield"></i></span>
                                <span className="nxl-mtext">신고 관리</span><span className="nxl-arrow"><i
                                className="feather-chevron-right"></i></span>
                            </a>
                            <ul className="nxl-submenu">
                                <li className="nxl-item"><Link className="nxl-link" to="/adminReportedComments">신고 댓글 관리</Link></li>
                            </ul>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
    )

}

export default Menu;
